<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <b-img
        :src="currentLocale.img"
        height="14px"
        width="22px"
        :alt="currentLocale.locale"
      />
      <span class="ml-50 text-body">{{ currentLocale.name }}</span>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.locale"
      @click="changeLocale(localeObj.locale)"
    >
      <b-img
        :src="localeObj.img"
        height="14px"
        width="22px"
        :alt="localeObj.locale"
      />
      <span class="ml-50">{{ localeObj.name }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem, BImg } from 'bootstrap-vue'
import { localize } from 'vee-validate';
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BImg,
  },
  props: {
    clientId: {
      type: String,
      default: false
    }
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.find(l => l.locale === this.$i18n.locale)
    },
  },
  methods: {
    changeLocale(locale) {
      this.$i18n.locale = locale
      localize(locale)
    },
  },
  mounted() {
    // Search for client default language in local storage and set the locale
    if (localStorage.getItem("clientData")) {
      let clientLanguage = JSON.parse(localStorage.getItem("clientData")).default_language
      if (clientLanguage) this.changeLocale(clientLanguage)
    }
    // Update client data in local storage
    if (this.clientId) {
      this.getItem({ collection: 'client', query: { _id: oid(this.clientId) } })
        .then(response => {
          if (!response) throw new Error('Client not found')
          const clientData = response
          let clientLanguage = clientData.default_language
          if (clientLanguage) this.changeLocale(clientLanguage)
          localStorage.setItem('clientData', JSON.stringify(clientData))
        })
        .catch((err) => {
          console.log(err);
        })
    }
  },
  setup() {
    const { getItem } = useLambda()

    /* eslint-disable global-require */
    const locales = [
      {
        locale: 'es',
        img: require('@/assets/images/flags/es.png'),
        name: 'Español',
      },
      {
        locale: 'en',
        img: require('@/assets/images/flags/en.png'),
        name: 'English',
      },
      /*
      {
        locale: 'fr',
        img: require('@/assets/images/flags/fr.png'),
        name: 'French',
      },
      {
        locale: 'de',
        img: require('@/assets/images/flags/de.png'),
        name: 'German',
      },
      {
        locale: 'pt',
        img: require('@/assets/images/flags/pt.png'),
        name: 'Portuguese',
      },
      */
    ]
    /* eslint-disable global-require */

    return {
      getItem,
      locales,
    }
  },
}
</script>

<style>

</style>
